import { Code, Flex, IconButton, Link, Tooltip } from '@radix-ui/themes';
import { ExternalLinkIcon } from '@radix-ui/react-icons';

import { shortenHash } from '../../utils/hash';
import CopyButton from '../CopyButton';

interface HashShortenerProps {
  hash: string;
  link?: string;
  isHighlighted?: boolean;
}

const HashShortener = ({ hash, link, isHighlighted }: HashShortenerProps) => (
  <Flex gap="2" align="center">
    <Tooltip content={hash}>
      {link ? (
        <Link href={link}>
          <Code variant={isHighlighted ? 'outline' : 'ghost'}>
            {shortenHash(hash)}
          </Code>
        </Link>
      ) : (
        <Code variant={isHighlighted ? 'outline' : 'ghost'}>
          {shortenHash(hash)}
        </Code>
      )}
    </Tooltip>
    <CopyButton value={hash} />
    {link && (
      <Tooltip content="Open in new tab">
        <IconButton size="1" variant="ghost" color="gray" asChild>
          <a href={link} target="_blank" rel="noopener noreferrer">
            <ExternalLinkIcon />
          </a>
        </IconButton>
      </Tooltip>
    )}
  </Flex>
);

export default HashShortener;
